import React, { ReactNode } from "react";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import {
  borderRadius,
  colors,
  fontSize,
  fontWeight,
  gaps,
  padding,
} from "theme/defaultStyle";

const BarContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  height: 44,
  padding: `0 ${padding.xlarge2}`,
  backgroundColor: colors.blue15,
  color: colors.white,
  gap: gaps.medium1,
  borderRadius: borderRadius.small,
});

const CountLabel = styled(Typography)({
  fontSize: fontSize.small1,
  fontWeight: fontWeight.normal2,
  color: colors.white,
  whiteSpace: "nowrap",
});

const Spacer = styled(Box)({
  marginLeft: "auto",
  display: "flex",
  alignItems: "center",
  gap: gaps.small1,
});

const BulkButtonRoot = styled(Button)({
  color: colors.white,
  textTransform: "none",
  fontSize: fontSize.small1,
  fontWeight: fontWeight.bold1,
  padding: `${padding.xsmall1} ${padding.medium1}`,
  minWidth: 0,
  "& .MuiButton-startIcon": { marginRight: gaps.xsmall1 },
  "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
  "&.Mui-disabled": { color: "rgba(255,255,255,0.5)" },
  "&.primary": {
    backgroundColor: colors.white,
    color: colors.blue15,
    "&:hover": { backgroundColor: colors.grey10 },
  },
});

interface BulkActionBarProps {
  open: boolean;
  count: number;
  children: ReactNode;
}

const BulkActionBar = ({ open, count, children }: BulkActionBarProps) => {
  if (!open) return null;
  return (
    <BarContainer>
      <CountLabel>
        {count} item{count !== 1 ? "s" : ""} selected
      </CountLabel>
      <Spacer>{children}</Spacer>
    </BarContainer>
  );
};

export interface BulkButtonProps {
  icon?: ReactNode;
  label: string;
  primary?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export const BulkButton = ({
  icon,
  label,
  primary = false,
  onClick,
  disabled = false,
}: BulkButtonProps) => (
  <BulkButtonRoot
    className={primary ? "primary" : ""}
    startIcon={icon}
    onClick={onClick}
    disabled={disabled}
    variant="text"
    size="small"
  >
    {label}
  </BulkButtonRoot>
);

export default BulkActionBar;
